import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {first} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {getDefaultHttpHeaders} from '../utils/http-headers.utils';
import {
  ExpertWalletAccess,
  ExpertWalletRecipientPreview,
  ExpertWalletSendResponse,
} from '@models/expert-wallet.interface';

@Injectable({
  providedIn: 'root',
})
export class ExpertWalletService {
  private readonly http = inject(HttpClient);
  private readonly BASE_URL = environment.apiUrl + '/expert/wallet-qr';

  checkAccess(): Observable<ExpertWalletAccess> {
    return this.http.get<ExpertWalletAccess>(`${this.BASE_URL}/access`, {
      headers: getDefaultHttpHeaders().headers,
    }).pipe(first());
  }

  recipientsPreview(limit = 10): Observable<ExpertWalletRecipientPreview[]> {
    return this.http.get<ExpertWalletRecipientPreview[]>(`${this.BASE_URL}/recipients-preview`, {
      headers: getDefaultHttpHeaders().headers,
      params: {limit: String(limit)},
    }).pipe(first());
  }

  sendAll(): Observable<ExpertWalletSendResponse> {
    return this.http.post<ExpertWalletSendResponse>(`${this.BASE_URL}/send-all`, {}, {
      headers: getDefaultHttpHeaders().headers,
    }).pipe(first());
  }
}
